import { React, useState } from "react";
import Navbar from "./../components/Navbar";
import IndexPage from "./index";
import AboutPage from "./about";
import FaqPage from "./faq";
import ContactPage from "./contact";
import PricingPage from "./pricing";
import DashboardPage from "./dashboard";
import AuthPage from "./auth";
import SettingsPage from "./settings";
import LegalPage from "./legal";
import VerifyPage from "./verify";
import EnterShowInfoPage from './enter-show-info'
import LegalMobilePage from "./legalMobilePage";
import { Switch, Route, Router } from "./../util/router";
import AuthRoutes, { PublicRoute, ProtectedRoute } from "../util/authRoutes";
import PurchasePage from "./purchase";
import FirebaseActionPage from "./firebase-action";
import NotFoundPage from "./404";
import Footer from "./../components/Footer";
import "./../util/analytics";
import { GoogleMapsProvider } from "./../providers/GoogleMapsProvider";
import { DateProvider } from "./../providers/DateProvider";
import { AuthProvider } from "./../util/auth";
import { ThemeProvider } from "./../util/theme";
import { QueryClientProvider } from "./../util/db";
import { Toaster } from 'react-hot-toast';
import "./styles.css";
import "../../src/styleOverrides.css";
import "react-datepicker/dist/react-datepicker.css";

function App(props) { 
  return (
    <QueryClientProvider>
      <ThemeProvider>
        <AuthProvider>
        <GoogleMapsProvider>
        <DateProvider>
          <Router>
            <>
              <Navbar
                color="default"
                logo="/showNAVLogo.png"
                // logo="/pinsLogo.png"
                // logoInverted="/pinsLogo.png"
              />
              <Toaster />
                <AuthRoutes />
              <Footer
                bgColor="light"
                size="normal"
                bgImage=""
                bgImageOpacity={1}
                description="A short description of what you do here"
                copyright={`© ${new Date().getFullYear()} showNAV`}
                logo="/showNAVLogo.png"
                // logo="/pinsLogo.png"
                // logoInverted="/pinsLogo.png"
                sticky={true}
              />
            </>
          </Router>
          </DateProvider>
          </GoogleMapsProvider>
        </AuthProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
